module.exports = __webpack_public_path__ + "ncrpc-logo-og.jpg?9256a1f835017f277df7ca3be7bfa87f";